//      
import {
                
                
  calculateBox,
  withScroll,
} from 'css-box-model';
             
                      
                     
              
                     
import { origin } from '../../state/position';

export default function getDimension(
  descriptor                     ,
  el             ,
  windowScroll            = origin,
)                     {
  const computedStyles                      = window.getComputedStyle(el);
  const borderBox             = el.getBoundingClientRect();
  const client           = calculateBox(borderBox, computedStyles);
  const page           = withScroll(client, windowScroll);

  const placeholder              = {
    client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display,
  };
  const displaceBy           = {
    x: client.marginBox.width,
    y: client.marginBox.height,
  };

  const dimension                     = {
    descriptor,
    placeholder,
    displaceBy,
    client,
    page,
  };

  return dimension;
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-draggable-publisher/get-dimension.js